import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import GroupStore from '../../../GroupStore';
import GroupsStore from '../../../GroupsStore';
import { GroupResource, GroupResources } from '../../../GroupsStore/Types';
import { MulticheckStore } from '../../../Multicheck/Store';
import { T } from '../../../Translations';
import ModalStore from '../../Modal/Store';
import Table from './Table';

interface Props {
  store: GroupsStore;
  groupStore: GroupStore;
  modalStore: ModalStore;
  multicheckStore: MulticheckStore<GroupResource>;
  groupsResource: GroupResources;
}

function TableOrEmpty({ store, groupsResource, modalStore, groupStore, multicheckStore }: Props) {
  return fromEmpty(groupsResource)
    .map((groups) => (
      <Table
        store={store}
        groupResources={groups}
        modalStore={modalStore}
        groupStore={groupStore}
        multicheckStore={multicheckStore}
      />
    ))
    .getOrElse(() => <T kind="No Groups" />);
}

export default observer(TableOrEmpty);
